/**
 * UGC Videoslider
 * -----------------------------------------------------------------------------
 * - Ingen videofil lastes før den faktisk skal spilles.
 * - Autospill uten lyd på FØRSTE synlige video. Ny video tar over ved scroll.
 * - Kun én video spiller om gangen. Pauser når seksjonen forlater viewporten
 *   eller fanen skjules.
 * - Klikk aapner modal med lyd og full avspillingskontroll.
 */
(function () {
  'use strict';

  if (window.customElements && customElements.get('ugc-video-slider')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function saveData() {
    var c = navigator.connection;
    if (!c) return false;
    if (c.saveData) return true;
    return c.effectiveType === 'slow-2g' || c.effectiveType === '2g';
  }

  function readData(slide) {
    if (slide.__ugcvData) return slide.__ugcvData;
    var node = slide.querySelector('[data-ugcv-data]');
    try {
      slide.__ugcvData = JSON.parse(node.textContent);
    } catch (e) {
      slide.__ugcvData = { sources: [] };
    }
    return slide.__ugcvData;
  }

  /** Velger den minste kilden som dekker skjermbredden. */
  function pickSource(sources, targetWidth) {
    if (!sources || !sources.length) return null;
    for (var i = 0; i < sources.length; i++) {
      if (sources[i].width >= targetWidth) return sources[i].url;
    }
    return sources[sources.length - 1].url;
  }

  /* --------------------------------------------------------------------------
   * Modal — én delt instans for hele siden
   * ------------------------------------------------------------------------ */
  var Modal = {
    el: null,
    video: null,
    slider: null,
    index: -1,

    build: function () {
      if (this.el) return;

      var dialog = document.createElement('dialog');
      dialog.className = 'ugcv-modal';
      dialog.setAttribute('aria-label', 'Produktvideo');
      dialog.innerHTML =
        '<div class="ugcv-modal__frame">' +
        '<video class="ugcv-modal__video" playsinline controls preload="none"></video>' +
        '<button type="button" class="ugcv-modal__btn ugcv-modal__close" aria-label="Lukk">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
        '<button type="button" class="ugcv-modal__btn ugcv-modal__prev" aria-label="Forrige video">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg></button>' +
        '<button type="button" class="ugcv-modal__btn ugcv-modal__next" aria-label="Neste video">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>' +
        '</div>' +
        '<div class="ugcv-modal__bar">' +
        '<span class="ugcv-modal__name"></span>' +
        '<a class="ugcv-modal__cta" hidden></a>' +
        '</div>';

      document.body.appendChild(dialog);

      this.el = dialog;
      this.video = dialog.querySelector('.ugcv-modal__video');
      this.name = dialog.querySelector('.ugcv-modal__name');
      this.cta = dialog.querySelector('.ugcv-modal__cta');
      this.prevBtn = dialog.querySelector('.ugcv-modal__prev');
      this.nextBtn = dialog.querySelector('.ugcv-modal__next');

      var self = this;
      dialog.querySelector('.ugcv-modal__close').addEventListener('click', function () {
        dialog.close();
      });
      this.prevBtn.addEventListener('click', function () {
        self.show(self.index - 1);
      });
      this.nextBtn.addEventListener('click', function () {
        self.show(self.index + 1);
      });

      // Klikk paa backdrop lukker
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', function () {
        self.teardown();
      });

      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          self.show(self.index + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          self.show(self.index - 1);
        }
      });
    },

    open: function (slider, index) {
      this.build();
      this.slider = slider;
      this.opener = slider.slides[index].querySelector('[data-ugcv-open]');
      slider.pauseAll();
      document.documentElement.classList.add('ugcv-locked');

      if (typeof this.el.showModal === 'function') {
        this.el.showModal();
      } else {
        this.el.setAttribute('open', '');
      }
      this.show(index);
    },

    show: function (index) {
      var slides = this.slider.slides;
      if (index < 0) index = slides.length - 1;
      if (index > slides.length - 1) index = 0;
      this.index = index;

      var slide = slides[index];
      var data = readData(slide);
      var card = slide.querySelector('.ugcv__video');
      var startAt = card && card.currentTime ? card.currentTime : 0;

      var dpr = window.devicePixelRatio || 1;
      var target = Math.min(1080, Math.round(Math.min(window.innerWidth, 520) * dpr));
      var url = pickSource(data.sources, target);

      var video = this.video;
      video.pause();
      if (data.poster) video.poster = data.poster;

      // Sett rammens sideforhold foer avspilling, slik at det aldri vises
      // svarte felt rundt videoen. Kildene har kjente dimensjoner.
      var dims = null;
      for (var s = 0; s < data.sources.length; s++) {
        if (data.sources[s].url === url) dims = data.sources[s];
      }
      if (!dims) dims = data.sources[data.sources.length - 1];
      if (dims && dims.width && dims.height) this.setRatio(dims.width, dims.height);

      video.src = url;
      video.muted = false;

      var self = this;
      var onMeta = function () {
        if (video.videoWidth && video.videoHeight) {
          self.setRatio(video.videoWidth, video.videoHeight);
        }
        try {
          if (startAt > 0 && startAt < video.duration) video.currentTime = startAt;
        } catch (e) {}
      };
      video.addEventListener('loadedmetadata', onMeta, { once: true });

      var playing = video.play();
      if (playing && playing.catch) {
        playing.catch(function () {
          /* Nettleseren blokkerte lyd — brukeren trykker paa play. */
        });
      }

      this.name.textContent = data.name || '';
      this.el.setAttribute('aria-label', data.label || 'Produktvideo');

      if (data.hasCta) {
        this.cta.href = data.ctaUrl;
        this.cta.textContent = data.ctaLabel;
        this.cta.hidden = false;
      } else {
        this.cta.hidden = true;
      }

      var single = slides.length < 2;
      this.prevBtn.hidden = single;
      this.nextBtn.hidden = single;
    },

    setRatio: function (width, height) {
      this.el.style.setProperty('--ugcv-mw', width);
      this.el.style.setProperty('--ugcv-mh', height);
    },

    teardown: function () {
      document.documentElement.classList.remove('ugcv-locked');
      var video = this.video;
      video.pause();
      video.removeAttribute('src');
      video.load();
      if (this.opener) {
        this.opener.focus();
        this.opener = null;
      }
      // Nullstill foer resume(), som avbryter hvis Modal.slider fortsatt er satt.
      var slider = this.slider;
      this.slider = null;
      this.index = -1;
      if (slider) slider.resume();
    }
  };

  /* --------------------------------------------------------------------------
   * Slider
   * ------------------------------------------------------------------------ */
  class UgcVideoSlider extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;

      this.track = this.querySelector('[data-ugcv-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ugcv-slide]'));
      if (!this.track || !this.slides.length) return;

      this.autoplayEnabled = this.dataset.autoplay === 'true' && !REDUCED.matches;
      this.visible = {};
      this.current = -1;
      this.inView = false;

      var self = this;

      this.slides.forEach(function (slide, index) {
        var button = slide.querySelector('[data-ugcv-open]');
        if (button) {
          button.addEventListener('click', function () {
            Modal.open(self, index);
          });
        }
      });

      this.setupObservers();
      this.setupNav();

      this.onVisibility = function () {
        if (document.hidden) self.pauseAll();
        else self.resume();
      };
      document.addEventListener('visibilitychange', this.onVisibility);

      this.onMotionChange = function () {
        self.autoplayEnabled = self.dataset.autoplay === 'true' && !REDUCED.matches;
        if (self.autoplayEnabled) self.resume();
        else self.pauseAll();
      };
      if (REDUCED.addEventListener) REDUCED.addEventListener('change', this.onMotionChange);
    }

    disconnectedCallback() {
      if (this.sectionObserver) this.sectionObserver.disconnect();
      if (this.slideObserver) this.slideObserver.disconnect();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.onMotionChange && REDUCED.removeEventListener) {
        REDUCED.removeEventListener('change', this.onMotionChange);
      }
      this.__ready = false;
    }

    setupObservers() {
      var self = this;

      // Er seksjonen i viewporten i det hele tatt?
      this.sectionObserver = new IntersectionObserver(
        function (entries) {
          self.inView = entries[0].isIntersecting;
          if (self.inView) self.resume();
          else self.pauseAll();
        },
        { threshold: 0.25 }
      );
      this.sectionObserver.observe(this);

      // Hvilke slides er horisontalt synlige i sporet?
      this.slideObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var index = Number(entry.target.dataset.index);
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              self.visible[index] = true;
            } else {
              delete self.visible[index];
            }
          });
          self.syncCurrent();
        },
        { root: this.track, threshold: [0, 0.6, 1] }
      );
      this.slides.forEach(function (slide) {
        self.slideObserver.observe(slide);
      });
    }

    /** Første synlige slide vinner. */
    firstVisible() {
      var keys = Object.keys(this.visible);
      if (!keys.length) return -1;
      return keys
        .map(Number)
        .sort(function (a, b) {
          return a - b;
        })[0];
    }

    syncCurrent() {
      var next = this.firstVisible();
      if (next === -1 || next === this.current) return;

      if (this.current > -1) this.stop(this.slides[this.current]);
      this.current = next;

      if (this.inView && this.autoplayEnabled && !Modal.slider) {
        this.play(this.slides[next]);
        this.warm(next + 1);
      }
    }

    resume() {
      if (!this.inView || !this.autoplayEnabled || Modal.slider) return;
      if (this.current === -1) this.current = this.firstVisible();
      if (this.current === -1) this.current = 0;
      this.play(this.slides[this.current]);
      this.warm(this.current + 1);
    }

    hydrate(slide) {
      var video = slide.querySelector('.ugcv__video');
      if (!video || video.getAttribute('src')) return video;
      var data = readData(slide);
      if (!data.preview) return null;
      video.setAttribute('src', data.preview);
      return video;
    }

    /** Forbereder neste video slik at scroll føles umiddelbart. */
    warm(index) {
      if (saveData() || index < 0 || index >= this.slides.length) return;
      var video = this.hydrate(this.slides[index]);
      if (video && video.preload === 'none') video.preload = 'metadata';
    }

    play(slide) {
      if (!slide) return;
      var video = this.hydrate(slide);
      if (!video) return;
      video.preload = 'auto';
      video.muted = true;
      var playing = video.play();
      if (playing && playing.then) {
        playing
          .then(function () {
            slide.classList.add('is-playing');
          })
          .catch(function () {
            slide.classList.remove('is-playing');
          });
      } else {
        slide.classList.add('is-playing');
      }
    }

    stop(slide) {
      if (!slide) return;
      var video = slide.querySelector('.ugcv__video');
      if (!video) return;
      video.pause();
      slide.classList.remove('is-playing');
    }

    pauseAll() {
      var self = this;
      this.slides.forEach(function (slide) {
        self.stop(slide);
      });
    }

    setupNav() {
      var self = this;
      this.prevBtn = this.querySelector('[data-ugcv-prev]');
      this.nextBtn = this.querySelector('[data-ugcv-next]');
      if (!this.prevBtn || !this.nextBtn) return;

      var step = function () {
        var first = self.slides[0];
        if (!first) return 0;
        var styles = getComputedStyle(self.track);
        var gap = parseFloat(styles.columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      this.prevBtn.addEventListener('click', function () {
        self.track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      this.nextBtn.addEventListener('click', function () {
        self.track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      var update = function () {
        var max = self.track.scrollWidth - self.track.clientWidth;
        self.classList.toggle('is-overflowing', max > 4);
        self.prevBtn.disabled = self.track.scrollLeft <= 4;
        self.nextBtn.disabled = self.track.scrollLeft >= max - 4;
      };

      this.track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(this.track);
      } else {
        window.addEventListener('resize', update);
      }
      update();
    }
  }

  customElements.define('ugc-video-slider', UgcVideoSlider);
})();
